import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/login';
import DashBoard from './pages/dashboard';
import ArtworkURLDetail from './pages/artworkURL';
import ArtworkNameDetail from './pages/artworkName';
import AILogs from './pages/ailog';
import Warn from './pages/warn';
import WarnDetail from './pages/warn/detail';
import { ProtectedRoute, UnprotectedRoute } from './components/protectedroute';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/login"
          element={
            <UnprotectedRoute>
              <Login />
            </UnprotectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashBoard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artwork/url/:artworkId"
          element={
            <ProtectedRoute>
              <ArtworkURLDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artwork/name/:artworkId"
          element={
            <ProtectedRoute>
              <ArtworkNameDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ailog"
          element={
            <ProtectedRoute>
              <AILogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/warn"
          element={
            <ProtectedRoute>
              <Warn />
            </ProtectedRoute>
          }
        />
        <Route
          path="/warndetail"
          element={
            <ProtectedRoute>
              <WarnDetail />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  );
}

export default App;
